module.exports = {
  "source": ".ExitBanner__bulletListItem___2nRM4{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  text-align:center;\n  line-height:1.5em;\n  margin-bottom:1em; }\n.ExitBanner__vertical___3xBQR{\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n      -ms-flex-direction:column;\n          flex-direction:column; }\n.ExitBanner__vertical___3xBQR .ExitBanner__imageContainer___2ASsH{\n    margin-right:0; }\n.ExitBanner__imageContainer___2ASsH{\n  margin-right:15px; }\n.ExitBanner__imageContainer___2ASsH .svgIcon,\n  .ExitBanner__imageContainer___2ASsH .svgIcon *{\n    width:30px;\n    height:30px; }\n.ExitBanner__contentContainer___DtEgo{\n  margin-top:20px; }\n.ExitBanner__contentContainer___DtEgo .component-header{\n    margin-bottom:30px; }\n.ExitBanner__contentContainer___DtEgo .svgIcon,\n  .ExitBanner__contentContainer___DtEgo .svgIcon *{\n    width:30px;\n    height:30px; }\n",
  "classNames": {
    "bulletListItem": "ExitBanner__bulletListItem___2nRM4",
    "vertical": "ExitBanner__vertical___3xBQR",
    "imageContainer": "ExitBanner__imageContainer___2ASsH",
    "contentContainer": "ExitBanner__contentContainer___DtEgo"
  },
  "classNameHash": {
    "ExitBanner__bulletListItem___2nRM4": "bulletListItem",
    "ExitBanner__vertical___3xBQR": "vertical",
    "ExitBanner__imageContainer___2ASsH": "imageContainer",
    "ExitBanner__contentContainer___DtEgo": "contentContainer"
  }
};

module.exports.getClassName = function(name, defaultValue) {
    return module.exports.classNames[name] || defaultValue;
};

module.exports.getClassNameHash = function(name, defaultValue) {
  return module.exports.classNameHash[name] || defaultValue;
};

module.exports.toString = function() {
  return module.exports.source;
};
